<template>
 <div>
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
      <div class="content-wrapper list-users">
      <div class="container-wrapper center">
      <div><h3 class="d-inline heading">List Users</h3></div>
      <div class="heading-seperator"></div>
    <div class="user-count-wrapper">
      <b-container class="user_lists_grid">
        <b-row>
            <b-col><span class="bold font-25">{{accountUserCount.accountcnt}}</span> <br /> Accounts</b-col>
            <b-col><span class="bold font-25">{{accountUserCount.mentorcnt}}</span> <br /> Mentors</b-col>
            <b-col><span class="bold font-25">{{accountUserCount.instructorcnt}}</span> <br /> Instructors</b-col>
            <b-col><span class="bold font-25">{{accountUserCount.menteecnt}}</span> <br /> Mentees / Students</b-col>
        </b-row>
      </b-container>
    </div>
    <div style="clear: both"></div>
    <flash-message autoHide variant="success"></flash-message>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="ACCOUNTS" @click="selected_component('Accountlists')" v-bind:active="isActive('Accountlists')">
        </b-tab>
        <b-tab title="USERS" @click="selected_component('Userlists')" v-bind:active="isActive('Userlists')">
        </b-tab>
        <keep-alive>
            <component :is="selectedComponent">
            </component>
        </keep-alive>
      </b-tabs>
    </b-card>
    </div>
  </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import Userlists from './userlists.vue';
import Accountlists from './accountlists.vue';
import store from '../../store/store.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';

export default {
    data() {
          return {
            selectedComponent: 'accountlists',
            accountUserCount: [],
          }
    },
    components: {
          UserMenu,
          GoBack,
          Userlists,
          Accountlists,
          MasteradminSidebarMenu
    },
    methods: {
         isActive: function (tabvalue) {
            return this.selectedComponent === tabvalue
         },
         selected_component: function (tabvalue) {
            this.selectedComponent = tabvalue;
            let page_url = 'ListUsers';
            let active_tab = tabvalue;
            this.$store.dispatch('active_tab', { page_url, active_tab })
         }
    },
    created() {
      if((this.$store.state.page_url) && (this.$store.state.page_url === 'ListUsers')) {
        this.selectedComponent = this.$store.state.active_tab;
      }
      axios.get('/users-count')
      .then((resp) => {
          this.accountUserCount = resp.data[0];
      })
      .catch(error => {

      });
    }
}
</script>

<style>
.user_lists_grid .col {
  border: 1px solid #8b8b8b;
  text-align: center;
  font-size: 16px;
  background-color: #FFF;
  color: #1C85C8;
}
.container {
  max-width: 100% !important;
  padding: 0px !important;
}
.container .row {
  margin: 0px;
}
.font-25 {
  font-size: 25px;
}
@media(max-width:560px) {
.user_lists_grid {
  margin-top: 62px;
}
}
@media (min-width: 1204px) {
  .container-wrapper {
    width: 95%;
  }
}
.user-count-wrapper {
  padding-top: 10px;
}
.list-users .page-link {
    color: #007bff !important;
    font-weight: normal;
}
.list-users .page-item.active .page-link {
    color: #FFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/listusers.vue